export const getJobActivities = async (token, jobId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Job/GetJobActivities`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ JobId: jobId }),
    });

    const result = await response.json();

    if (result.success === 1 && Array.isArray(result.data)) {
      return result.data;
    }

    return [];
  } catch (error) {
    console.error("Error obteniendo actividades:", error);
    return [];
  }
};

export const saveJobActivities = async (token, jobId, activities) => {
  try {
    const body = {
      JobId: jobId,
      Activities: activities,
    };

    console.log("Activities  --->", activities)
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Job/SaveJobActivityTakes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error al guardar actividades:", error);
    return { success: 0, message: "Error de conexión con el servidor." };
  }
};